export default __webpack_public_path__ + "static/media/blogIcon.b597fa3b.svg";